/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1RefundsCancelSubscriptionPost200Response } from '../models';
// @ts-ignore
import type { ApiV1RefundsEligibilityOrderIdGet200Response } from '../models';
// @ts-ignore
import type { ApiV1RefundsMyRequestsGet200Response } from '../models';
// @ts-ignore
import type { ApiV1RefundsRequestPost200Response } from '../models';
// @ts-ignore
import type { CancelSubscriptionDto } from '../models';
// @ts-ignore
import type { ErrorResponse1 } from '../models';
// @ts-ignore
import type { RefundRequestDto } from '../models';
/**
 * RefundsApi - axios parameter creator
 * @export
 */
export const RefundsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 구독을 취소합니다. 환불이 아닌 다음 결제일부터 결제가 중단됩니다. 현재 결제 기간은 그대로 이용 가능합니다. 
         * @summary 구독 취소 (환불 아님)
         * @param {CancelSubscriptionDto} cancelSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RefundsCancelSubscriptionPost: async (cancelSubscriptionDto: CancelSubscriptionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelSubscriptionDto' is not null or undefined
            assertParamExists('apiV1RefundsCancelSubscriptionPost', 'cancelSubscriptionDto', cancelSubscriptionDto)
            const localVarPath = `/api/v1/refunds/cancel-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 주문 ID를 기반으로 환불 가능 여부를 확인합니다. AI API 사용량을 조회하여 환불 가능 여부를 판단합니다. 
         * @summary 환불 가능 여부 확인
         * @param {string} orderId 주문 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RefundsEligibilityOrderIdGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('apiV1RefundsEligibilityOrderIdGet', 'orderId', orderId)
            const localVarPath = `/api/v1/refunds/eligibility/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 현재 사용자의 모든 환불 신청 내역을 조회합니다.
         * @summary 사용자의 환불 신청 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RefundsMyRequestsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/refunds/my-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * AI API 사용량을 기준으로 환불 신청을 처리합니다. - AI API를 사용하지 않았으면 전액 환불 가능 - AI API를 사용했으면 환불 불가능 
         * @summary 구독 환불 신청
         * @param {RefundRequestDto} refundRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RefundsRequestPost: async (refundRequestDto: RefundRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refundRequestDto' is not null or undefined
            assertParamExists('apiV1RefundsRequestPost', 'refundRequestDto', refundRequestDto)
            const localVarPath = `/api/v1/refunds/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RefundsApi - functional programming interface
 * @export
 */
export const RefundsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RefundsApiAxiosParamCreator(configuration)
    return {
        /**
         * 구독을 취소합니다. 환불이 아닌 다음 결제일부터 결제가 중단됩니다. 현재 결제 기간은 그대로 이용 가능합니다. 
         * @summary 구독 취소 (환불 아님)
         * @param {CancelSubscriptionDto} cancelSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RefundsCancelSubscriptionPost(cancelSubscriptionDto: CancelSubscriptionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1RefundsCancelSubscriptionPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RefundsCancelSubscriptionPost(cancelSubscriptionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RefundsApi.apiV1RefundsCancelSubscriptionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 주문 ID를 기반으로 환불 가능 여부를 확인합니다. AI API 사용량을 조회하여 환불 가능 여부를 판단합니다. 
         * @summary 환불 가능 여부 확인
         * @param {string} orderId 주문 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RefundsEligibilityOrderIdGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1RefundsEligibilityOrderIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RefundsEligibilityOrderIdGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RefundsApi.apiV1RefundsEligibilityOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 현재 사용자의 모든 환불 신청 내역을 조회합니다.
         * @summary 사용자의 환불 신청 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RefundsMyRequestsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1RefundsMyRequestsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RefundsMyRequestsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RefundsApi.apiV1RefundsMyRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * AI API 사용량을 기준으로 환불 신청을 처리합니다. - AI API를 사용하지 않았으면 전액 환불 가능 - AI API를 사용했으면 환불 불가능 
         * @summary 구독 환불 신청
         * @param {RefundRequestDto} refundRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RefundsRequestPost(refundRequestDto: RefundRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1RefundsRequestPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RefundsRequestPost(refundRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RefundsApi.apiV1RefundsRequestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RefundsApi - factory interface
 * @export
 */
export const RefundsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RefundsApiFp(configuration)
    return {
        /**
         * 구독을 취소합니다. 환불이 아닌 다음 결제일부터 결제가 중단됩니다. 현재 결제 기간은 그대로 이용 가능합니다. 
         * @summary 구독 취소 (환불 아님)
         * @param {RefundsApiApiV1RefundsCancelSubscriptionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RefundsCancelSubscriptionPost(requestParameters: RefundsApiApiV1RefundsCancelSubscriptionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1RefundsCancelSubscriptionPost200Response> {
            return localVarFp.apiV1RefundsCancelSubscriptionPost(requestParameters.cancelSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 주문 ID를 기반으로 환불 가능 여부를 확인합니다. AI API 사용량을 조회하여 환불 가능 여부를 판단합니다. 
         * @summary 환불 가능 여부 확인
         * @param {RefundsApiApiV1RefundsEligibilityOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RefundsEligibilityOrderIdGet(requestParameters: RefundsApiApiV1RefundsEligibilityOrderIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1RefundsEligibilityOrderIdGet200Response> {
            return localVarFp.apiV1RefundsEligibilityOrderIdGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 현재 사용자의 모든 환불 신청 내역을 조회합니다.
         * @summary 사용자의 환불 신청 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RefundsMyRequestsGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1RefundsMyRequestsGet200Response> {
            return localVarFp.apiV1RefundsMyRequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * AI API 사용량을 기준으로 환불 신청을 처리합니다. - AI API를 사용하지 않았으면 전액 환불 가능 - AI API를 사용했으면 환불 불가능 
         * @summary 구독 환불 신청
         * @param {RefundsApiApiV1RefundsRequestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RefundsRequestPost(requestParameters: RefundsApiApiV1RefundsRequestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1RefundsRequestPost200Response> {
            return localVarFp.apiV1RefundsRequestPost(requestParameters.refundRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RefundsApi - interface
 * @export
 * @interface RefundsApi
 */
export interface RefundsApiInterface {
    /**
     * 구독을 취소합니다. 환불이 아닌 다음 결제일부터 결제가 중단됩니다. 현재 결제 기간은 그대로 이용 가능합니다. 
     * @summary 구독 취소 (환불 아님)
     * @param {RefundsApiApiV1RefundsCancelSubscriptionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApiInterface
     */
    apiV1RefundsCancelSubscriptionPost(requestParameters: RefundsApiApiV1RefundsCancelSubscriptionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1RefundsCancelSubscriptionPost200Response>;

    /**
     * 주문 ID를 기반으로 환불 가능 여부를 확인합니다. AI API 사용량을 조회하여 환불 가능 여부를 판단합니다. 
     * @summary 환불 가능 여부 확인
     * @param {RefundsApiApiV1RefundsEligibilityOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApiInterface
     */
    apiV1RefundsEligibilityOrderIdGet(requestParameters: RefundsApiApiV1RefundsEligibilityOrderIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1RefundsEligibilityOrderIdGet200Response>;

    /**
     * 현재 사용자의 모든 환불 신청 내역을 조회합니다.
     * @summary 사용자의 환불 신청 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApiInterface
     */
    apiV1RefundsMyRequestsGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1RefundsMyRequestsGet200Response>;

    /**
     * AI API 사용량을 기준으로 환불 신청을 처리합니다. - AI API를 사용하지 않았으면 전액 환불 가능 - AI API를 사용했으면 환불 불가능 
     * @summary 구독 환불 신청
     * @param {RefundsApiApiV1RefundsRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApiInterface
     */
    apiV1RefundsRequestPost(requestParameters: RefundsApiApiV1RefundsRequestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1RefundsRequestPost200Response>;

}

/**
 * Request parameters for apiV1RefundsCancelSubscriptionPost operation in RefundsApi.
 * @export
 * @interface RefundsApiApiV1RefundsCancelSubscriptionPostRequest
 */
export interface RefundsApiApiV1RefundsCancelSubscriptionPostRequest {
    /**
     * 
     * @type {CancelSubscriptionDto}
     * @memberof RefundsApiApiV1RefundsCancelSubscriptionPost
     */
    readonly cancelSubscriptionDto: CancelSubscriptionDto
}

/**
 * Request parameters for apiV1RefundsEligibilityOrderIdGet operation in RefundsApi.
 * @export
 * @interface RefundsApiApiV1RefundsEligibilityOrderIdGetRequest
 */
export interface RefundsApiApiV1RefundsEligibilityOrderIdGetRequest {
    /**
     * 주문 ID
     * @type {string}
     * @memberof RefundsApiApiV1RefundsEligibilityOrderIdGet
     */
    readonly orderId: string
}

/**
 * Request parameters for apiV1RefundsRequestPost operation in RefundsApi.
 * @export
 * @interface RefundsApiApiV1RefundsRequestPostRequest
 */
export interface RefundsApiApiV1RefundsRequestPostRequest {
    /**
     * 
     * @type {RefundRequestDto}
     * @memberof RefundsApiApiV1RefundsRequestPost
     */
    readonly refundRequestDto: RefundRequestDto
}

/**
 * RefundsApi - object-oriented interface
 * @export
 * @class RefundsApi
 * @extends {BaseAPI}
 */
export class RefundsApi extends BaseAPI implements RefundsApiInterface {
    /**
     * 구독을 취소합니다. 환불이 아닌 다음 결제일부터 결제가 중단됩니다. 현재 결제 기간은 그대로 이용 가능합니다. 
     * @summary 구독 취소 (환불 아님)
     * @param {RefundsApiApiV1RefundsCancelSubscriptionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public apiV1RefundsCancelSubscriptionPost(requestParameters: RefundsApiApiV1RefundsCancelSubscriptionPostRequest, options?: RawAxiosRequestConfig) {
        return RefundsApiFp(this.configuration).apiV1RefundsCancelSubscriptionPost(requestParameters.cancelSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 주문 ID를 기반으로 환불 가능 여부를 확인합니다. AI API 사용량을 조회하여 환불 가능 여부를 판단합니다. 
     * @summary 환불 가능 여부 확인
     * @param {RefundsApiApiV1RefundsEligibilityOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public apiV1RefundsEligibilityOrderIdGet(requestParameters: RefundsApiApiV1RefundsEligibilityOrderIdGetRequest, options?: RawAxiosRequestConfig) {
        return RefundsApiFp(this.configuration).apiV1RefundsEligibilityOrderIdGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 현재 사용자의 모든 환불 신청 내역을 조회합니다.
     * @summary 사용자의 환불 신청 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public apiV1RefundsMyRequestsGet(options?: RawAxiosRequestConfig) {
        return RefundsApiFp(this.configuration).apiV1RefundsMyRequestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * AI API 사용량을 기준으로 환불 신청을 처리합니다. - AI API를 사용하지 않았으면 전액 환불 가능 - AI API를 사용했으면 환불 불가능 
     * @summary 구독 환불 신청
     * @param {RefundsApiApiV1RefundsRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public apiV1RefundsRequestPost(requestParameters: RefundsApiApiV1RefundsRequestPostRequest, options?: RawAxiosRequestConfig) {
        return RefundsApiFp(this.configuration).apiV1RefundsRequestPost(requestParameters.refundRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

